import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["innerHTML"]

import { ref, reactive, onBeforeMount } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageBreadcrumbs',
  setup(__props) {

const pageBreadcrumbs = ref();
const pageBreadcrumbsInnerHtml = reactive({ value: null });

onBeforeMount(() => {
  pageBreadcrumbs.value = document.querySelector('[aria-label="breadcrumb"]');

  if (pageBreadcrumbs.value) {
    pageBreadcrumbs.value.parentNode.style.setProperty('display', 'none');
    pageBreadcrumbsInnerHtml.value = pageBreadcrumbs.value.innerHTML;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", {
      "aria-label": "breadcrumb",
      innerHTML: pageBreadcrumbsInnerHtml.value
    }, null, 8, _hoisted_2)
  ]))
}
}

})